module.exports = "<p>\r\n  redirect works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/redirect/redirect.component.html
// module id = ./src/app/redirect/redirect.component.html
// module chunks = main